import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { getWishlist, removeFromWishlist } from '../../actions/wishlist'
import FullPageLoader from '../../components/common/fullPageLoader'
import { toast } from 'react-toastify';
import { addToCart } from '../../actions/cart'
import Breadcrumb from '../common/breadcrumb';
import { Helmet } from "react-helmet";
import MobileView from '../common/mobileView';
// import {addToCartAndRemoveWishlist, removeFromWishlist} from '../../actions'
import { hover, unhover, removeDefault, shopBagDefault, wishlistDefault } from '../../components/common/MangoIcons'

class wishList extends Component {

    componentDidMount() {
        const options = {
            connection_id: this.props.connection_id,
            consumer_mobile_no: this.props.consumer_mobile_no,
        }
        this.props.getWishlist(options)
    }


    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }

    handleRemoveWishlistItem = (event, item) => {
        event.preventDefault();
        const options = {
            connection_id: this.props.connection_id,
            consumer_mobile_no: this.props.consumer_mobile_no,
            lot_code: item.ACW_LOT_CD,
        }
        // 
        this.props.removeFromWishlist(options);
    }

    addToCartAndRemoveWishlist = (event, item, quantity) => {
        event.preventDefault();
        if (this.props.isAuth) {
            const { connection_id, web_session_trans_id, booking_store_id, consumer_mobile_no } = this.props
            const options = {
                connection_id,
                web_session_trans_id,
                booking_store_id,
                consumer_mobile_no,
                quantity,
                lot_code: item.ACW_LOT_CD,
                barcode: item.ACW_EAN_CD
            }
            this.props.addToCart(options)

            setTimeout(() => {
                const wishlistOptions = { connection_id, consumer_mobile_no, lot_code: item.ACW_LOT_CD }
                this.props.removeFromWishlist(wishlistOptions)
            }, 100)
        }
        else {
            toast.error("Please login / Register to add items to Shopping bag.");
            this.props.history.push('/register');
        }
    }

    render() {
        // let wishlistItems = []
        const { wishlistItems, symbol, loading, cartItems } = this.props;
        
        // for adding product image property in wishlist data
        // for (const wishlist in items) {
        //     if (wishlist !== 'SKU_IMAGE')
        //         wishlistItems.push(
        //             {
        //                 ...items[wishlist],
        //                 product_image: items['SKU_IMAGE'] + items[wishlist]['SKU_IMAGE']
        //             })
        // }

        if (loading)
            return <div><FullPageLoader /></div>

        return (
            <div>
                {/* <Breadcrumb title={'Wishlist'} /> */}
                <Helmet>
                <title>{this.props.customer_name} | Wishlist </title>
                    <meta name="description" content="" />
                </Helmet>
                {wishlistItems.length > 0 ?
                    <section className="wishlist-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="mini-title">
                                        <span>Wishlist</span>
                                    </div>
                                    <div className="mini-title-divider"></div>
                                     {/* Mobile Titlw Section */}
                                    <div className="mobile-title">
                                        <img src={wishlistDefault} />
                                        <span>Wishlist ({wishlistItems.length})</span>
                                    </div>
                                    <div className="mobile-divider"></div>
                                    {/* Mobile Titlw Section Ends*/}
                                    <table className="table cart-table table-responsive-xs">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col">image</th>
                                                <th scope="col">product name</th>
                                                <th scope="col">price</th>
                                                <th scope="col">availability</th>
                                                <th scope="col">action</th>
                                            </tr>
                                        </thead>
                                        {wishlistItems.map((item, index) => {
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        <td>
                                                            <Link to={`${process.env.PUBLIC_URL}/PD/${item.ACW_LOT_CD}`}>
                                                                <img src={`${item.SKU_IMAGE}`} alt="" />
                                                            </Link>
                                                        </td>
                                                        <td><Link to={`${process.env.PUBLIC_URL}/PD/${item.ACW_LOT_CD}`} className="no-display-pls">{item.SKU_DESC}</Link>
                                                            {/* <div className="mobile-cart-content row">
                                                                <div className="col-xs-3">
                                                                    <p>in stock</p>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">{symbol}{item.LOT_SELLING_PRICE}
                                                                    </h2>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">
                                                                        <a href="javascript:void(0)" className="btn btn-solid" onClick={(e) => this.addToCartAndRemoveWishlist(e, item, 1)}
                                                                            style={{ padding: "0px 4px", marginTop: 10 }}>
                                                                            Move to Bag
                                                                        </a>
                                                                    </h2>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">
                                                                        <a href="javascript:void(0)" className="btn btn-solid" style={{ padding: "0px 4px", marginTop: 10 }}
                                                                            onClick={(event) => this.handleRemoveWishlistItem(event, item)}
                                                                        >
                                                                            Remove item
                                                                        </a>
                                                                    </h2>
                                                                </div>
                                                            </div> */}
                                                            <MobileView
                                                                view={'wish'}
                                                                data={item}
                                                                functions={{
                                                                    moveToBag: this.addToCartAndRemoveWishlist,
                                                                    removeWish: this.handleRemoveWishlistItem
                                                                }}
                                                            />
                                                        </td>
                                                        <td><h2>{symbol}{item.LOT_SELLING_PRICE}
                                                        </h2></td>
                                                        <td >
                                                            <p>in stock</p>
                                                        </td>
                                                        <td>
                                                            <a href="javascript:void(0)" title="Move to Bag" className="cart" onClick={(e) => this.addToCartAndRemoveWishlist(e, item, 1)} style={{ marginRight: 25 }}>
                                                                <img src={shopBagDefault} className="icon-hovers" width={30} height={30} />
                                                            </a>
                                                            <a href="javascript:void(0)" title="Remove item" className="icon" onClick={(event) => this.handleRemoveWishlistItem(event, item)}
                                                            >
                                                                {/* <i className="fa fa-times"></i> */}
                                                                <img src={removeDefault} className="icon-hovers" width={30} height={30} />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>)
                                        })}
                                    </table>
                                </div>
                            </div>
                            <div className="row wishlist-buttons">
                                <div className="col-12">
                                    {/* <Link to={`/`} className="btn btn-solid">continue shopping</Link> */}
                                    <button className="btn btn-solid" onClick={() => this.props.history.goBack()}>continue shopping</button>
                                    {cartItems.length > 0 ? <Link to={`${process.env.PUBLIC_URL}/cart`} className="btn btn-solid">Go To Cart</Link> : ''}
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div >
                                        <div className="col-sm-12 empty-cart-cls text-center">
                                            <img src={wishlistDefault} alt="Shopping Bag" width={50} height={50} />
                                            <h5>
                                                <strong>Your Wishlist is empty.</strong>
                                            </h5>
                                            <h5>Explore and Save items you like most.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    isAuth: state.user.isAuth,
    cartItems: state.cart.cartItems,
    wishlistItems: state.wishlist.wishlistItems,
    loading: state.wishlist.loading,
    symbol: state.data.symbol,
    connection_id: state.tenant.connection_id,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    consumer_mobile_no: state.user.user_details.COM_CONSUMER_MOBILE_NO,
    web_session_trans_id: state.user.user_details && state.user.web_session_trans_id,
    booking_store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
})

export default connect(
    mapStateToProps,
    { getWishlist, removeFromWishlist, addToCart }
)(withRouter(wishList))